import { jsx } from "react/jsx-runtime";
import { ResponsiveIframe } from "@zillow/zrs-cms";
import { omit } from "lodash";
import PropTypes from "prop-types";
import "react";
import { usePlacement } from "../../components/PlacementProvider/PlacementProvider.esm.js";
const BlockEmbed = ({
  attrs
}) => {
  const isPost = usePlacement() === "post";
  const {
    width = 1024,
    height = 768,
    allowFullScreen = true,
    loading = "lazy",
    title = "Embedded content",
    ...iframeAttributes
  } = attrs;
  return /* @__PURE__ */ jsx(ResponsiveIframe, { ...omit(iframeAttributes, "margin"), title, allowFullScreen, loading, width, height, ...isPost ? {
    marginBottom: "md"
  } : iframeAttributes.margin });
};
BlockEmbed.propTypes = {
  attrs: PropTypes.shape({
    url: PropTypes.string,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    allowFullScreen: PropTypes.bool,
    title: PropTypes.string,
    loading: PropTypes.string
  }),
  index: PropTypes.number
};
export {
  BlockEmbed as default
};
